const { BRAND } = process.env;

// 站点配置
const sitesConfig = {
  vn: {
    toshiba: {
      hideAddressFields: ["country", "district"],
    },
    comfee: {
      hideAddressFields: ["country", "district"],
    },
  },
};

// 获取站点配置
export default function getSiteConfig(site = "") {
  const siteConfig = sitesConfig[site] || {};
  return {
    ...siteConfig,
    // 将 brand 中的配置扁平化
    ...(siteConfig[BRAND] || {}),
  };
}
